// NOTE: THIS FILE IS AUTOGENERATED, PLEASE GET THE F**K OUT OF HERE
// tslint:disable
export const VERSION: string = '1744280878115';
// tslint:enable
